/**
 * Shared utility to translate exercise names/descriptions from backend type_id to i18n keys.
 * Used across ExerciseLibrary, ExerciseSelector, and individual exercise pages.
 */

// Map backend type_id to i18n key prefix
const TYPE_ID_TO_I18N = {
  emotion_register: "exercise.emotion_register", behavioral_activation: "exercise.behavioral_activation",
  cognitive_restructuring: "exercise.cognitive_restructuring", mood_tracking: "exercise.mood",
  pomodoro: "exercise.pomodoro", cognitive_defusion: "exercise.cognitive_defusion",
  meditation: "exercise.meditation", gratitude: "exercise.gratitude",
  self_reinforcement: "exercise.self_reinforcement", self_compassion: "exercise.self_compassion",
  values_exploration: "exercise.values_exploration", needs_exploration: "exercise.needs_exploration",
  problem_solving: "exercise.problem_solving", qualities_exploration: "exercise.qualities_exploration",
  capabilities_exploration: "exercise.capabilities_exploration", assertiveness: "exercise.assertiveness",
  barkley_identity_card: "barkley.identityCard", barkley_special_moment: "barkley.specialMoment",
  barkley_effective_instructions: "barkley.instructions", barkley_token_system: "barkley.tokenSystem",
  barkley_crisis_plan: "barkley.crisisPlan", barkley_abc_analysis: "barkley.abcAnalysis",
  barkley_child_volcano: "barkley.childVolcano", barkley_child_autonomy_timer: "barkley.childAutonomy",
  barkley_child_superpowers: "barkley.childSuperpowers", barkley_child_solution_wheel: "barkley.childSolutions",
  barkley_child_success_board: "barkley.childSuccess", barkley_child_instruction_detective: "barkley.childDetective",
  barkley_teen_situation_analysis: "barkley.teenSituation", barkley_teen_weekly_planner: "barkley.teenPlanner",
  ado_school_stress_journal: "ado.schoolStress", ado_exposure_plan: "ado.exposurePlan",
  perf_journal: "perf.journal", perf_good_enough: "perf.goodEnough", perf_cost_benefit: "perf.costBenefit", perf_standards_continuum: "perf.continuum",
  grief_memory_journal: "grief.memoryJournal", grief_letter: "grief.letter", grief_avoidance_hierarchy: "grief.avoidance", grief_reengagement_plan: "grief.reengagement",
  barkley_teen_emotion_journal: "barkley.teenEmotionJournal", barkley_teen_smart_goals: "barkley.teenSmartGoals",
  barkley_teen_cnv: "barkley.teenCNV", barkley_teen_weekly_review: "barkley.teenWeeklyReview",
  act_dropping_anchor: "act.droppingAnchor", act_expansion: "act.expansion",
  act_observer_self: "act.observerSelf", act_choice_point: "act.choicePoint",
  act_matrix: "act.matrix", act_committed_action: "act.committedAction",
  tdah_priorities_abc: "tdah.priorities", tdah_document_management: "tdah.documents",
  tdah_attention_capacity: "tdah.attention", tdah_automatic_thoughts: "tdah.thoughts",
  tdah_anti_procrastination: "tdah.procrastination", tdah_goals_motivation: "tdah.goals",
};

export const getExerciseName = (t, typeId, fallback) => {
  const prefix = TYPE_ID_TO_I18N[typeId];
  if (!prefix) return fallback || typeId;
  const isStandard = prefix.startsWith("exercise.");
  return isStandard ? t(prefix, fallback) : t(`${prefix}.title`, fallback);
};

export const getExerciseDesc = (t, typeId, fallback) => {
  const prefix = TYPE_ID_TO_I18N[typeId];
  if (!prefix) return fallback || "";
  return t(`${prefix}.desc`, fallback);
};
